import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import posthog from 'posthog-js';
import {
  extractErrorDiagnostics,
  ResponseHeaders,
} from '~/helpers/errorDiagnostics.helper';
import { logToSentry } from '~/helpers/loggers.helper';
import { setApiErrorDiagnostics } from '~/store/slices/globalError.slice';

const API_ERROR_DIAGNOSTICS_EVENT = 'myqred_api_error_diagnostics';

export const reportApiErrorDiagnostics = (
  dispatch: Dispatch<AnyAction>,
  headers: ResponseHeaders
): void => {
  const diagnostics = extractErrorDiagnostics(headers);

  if (!diagnostics) {
    return;
  }

  dispatch(setApiErrorDiagnostics(diagnostics));

  try {
    posthog.capture(API_ERROR_DIAGNOSTICS_EVENT, {
      errorId: diagnostics.errorId,
      traceId: diagnostics.traceId,
      requestId: diagnostics.requestId,
    });
  } catch (error) {
    // Swallowed on purpose: analytics must never break error handling.
    logToSentry(
      error,
      'reportApiErrorDiagnostics posthogCapture',
      undefined,
      'warning'
    );
  }
};
